import { ApplicationConfig, provideBrowserGlobalErrorListeners } from '@angular/core';
import { provideHttpClient, withInterceptors, withXsrfConfiguration } from '@angular/common/http';
import { provideRouter } from '@angular/router';

import { routes } from './app.routes';

import {
  credentialsInterceptor,
  csrfInterceptor,
  errorInterceptor,
} from '@app/core/helpers';

export const appConfig: ApplicationConfig = {
  providers: [
    provideHttpClient(
      withXsrfConfiguration({
        cookieName: 'XSRF-TOKEN',
        headerName: 'X-XSRF-TOKEN',
      }),
      withInterceptors([
        csrfInterceptor,
        credentialsInterceptor,
        errorInterceptor,
      ])
    ),
    provideBrowserGlobalErrorListeners(),
    provideRouter(routes)
  ]
};
